import { useDispatch } from "react-redux";
import { ModalCommonProps } from "./types";
import {
  ButtonGroup,
  StyledModal,
  WorkplaceContractFormModalTitle,
  WorkplaceContractFormModalHelpText,
} from "./styles";
import { Button } from "src/designsystem/Button/Button";
import { Link } from "../../../designsystem/Link/Link";
import { notification } from "antd";
import { EMAILS } from "src/constants/communications";
import { logout } from "@src/modules/session";

function WorkplaceSignContractUnverifiedUser({ closeModal, onSubmit }: ModalCommonProps) {
  const dispatch = useDispatch();

  const handleLogoutAndSignIn = async () => {
    closeModal();
    try {
      onSubmit();
    } catch {
      // Non-blocking: analytics failure should not prevent logout
    }
    try {
      await dispatch(logout());
    } catch {
      notification.error({
        message: "Failed to log out. Please try again.",
      });
    }
  };

  return (
    <StyledModal visible closable onCancel={closeModal} footer={null} cancelText={null}>
      <WorkplaceContractFormModalTitle level={3}>
        As a last step, we need to verify your email
      </WorkplaceContractFormModalTitle>
      <WorkplaceContractFormModalHelpText>
        To verify your account, please log out and sign back in using the email option. When you
        sign in again, your email will be automatically verified and you&apos;ll have full access to
        start posting shifts!
      </WorkplaceContractFormModalHelpText>
      <br />
      <WorkplaceContractFormModalHelpText>
        If you need help, please contact us at{" "}
        <Link href={`mailto:${EMAILS.getAccess}`}>{EMAILS.getAccess}</Link>.
      </WorkplaceContractFormModalHelpText>
      <ButtonGroup>
        <Button variant="primary" onClick={handleLogoutAndSignIn}>
          Log out and sign in
        </Button>
        <Button variant="secondary" onClick={closeModal}>
          Later
        </Button>
      </ButtonGroup>
    </StyledModal>
  );
}

export { WorkplaceSignContractUnverifiedUser };
